import { useCallback } from 'react';
import { odata } from '@bingads-webui/http-util';
import { useOdataOptions } from './use-odata-options';
import type { AigcRequestActivity } from './use-generate-business-snapshot';

const GET_API_NAME = 'odataapi/campaign/v2/accountsv2/getcampaignrecommendationresult';

export const useGetCampaignRecommendation = () => {
  const [odataOptions, { cid, aid }] = useOdataOptions('Advertiser/V2');

  return useCallback((taskId: string, activity?: AigcRequestActivity) => {
    const url = `AccountsV2/GetCampaignRecommendationResult(CustomerId=${cid},AccountId=${aid},TaskId='${taskId}')`;

    // Log request + response/error from a single jQuery `complete` callback
    // so all three trace lines carry the same x-ms-requestid (extracted
    // from the response headers). Pass `activity` only on the polls you
    // want logged (e.g. terminal status transitions) to avoid spamming.
    return odata.get({
      ...odataOptions,
      url,
      complete: (jqXHR: any, textStatus: string) => {
        if (!activity) return;
        const requestId =
          (jqXHR && typeof jqXHR.getResponseHeader === 'function')
            ? (jqXHR.getResponseHeader('x-ms-requestid') ?? undefined)
            : undefined;
        const isSuccess = textStatus === 'success'
          || textStatus === 'notmodified'
          || textStatus === 'nocontent';

        activity.trace(
          `[PMaxLiteSignup][AgenticOnboarding] GetCampaignRecommendationResult request: taskId=${taskId}`,
          GET_API_NAME,
          requestId
        );

        if (isSuccess) {
          const responseBody = jqXHR?.responseJSON;
          const status = responseBody?.Data?.Status ?? '';
          const nextAction = responseBody?.Data?.NextAction ?? '';
          activity.trace(
            `[PMaxLiteSignup][AgenticOnboarding] GetCampaignRecommendationResult response: taskId=${taskId} status=${status} nextAction=${nextAction}`,
            GET_API_NAME,
            requestId
          );
        } else {
          const errorBody = jqXHR?.responseJSON ?? jqXHR?.responseText ?? jqXHR?.statusText ?? textStatus;
          activity.error(
            `[PMaxLiteSignup][AgenticOnboarding] GetCampaignRecommendationResult failed: taskId=${taskId} httpStatus=${jqXHR?.status} textStatus=${textStatus} ${JSON.stringify(errorBody)}`,
            GET_API_NAME,
            requestId
          );
        }
      },
    } as any);
  }, [odataOptions, cid, aid]);
};
